import { round } from "lodash";

export function formatLargeValue(value: number): string {
  if (value >= 1000000000) {
    return round(value / 1000000000, 2).toString() + "B";
  } else if (value >= 1000000) {
    return round(value / 1000000, 2).toString() + "M";
  } else if (value >= 100000) {
    return round(value / 1000, 2).toString() + "K";
  }
  return value ? value.toString() : `${value}`;
}
